import { produce } from 'immer'
import { ADD_MODULE_CONTEXT_CODE_SUCCESS, UPDATE_TRANSLATIONS_SUCCESS } from '../actions/intl'

export default produce((draft, action) => {
    switch (action.type) {
        case UPDATE_TRANSLATIONS_SUCCESS:
            {
                const { locale, translations } = action
                Object.assign(draft, { locale })
                if (Array.isArray(translations) && translations.length > 0) {
                    /*
                  The translations are provided in the following format:
                  [
                  {
                  "stringCode": "...",
                  "translation": "..."
                  }
                  ]
                  Transform it to the following format, which is more convenient to use and to cache:
                  {
                  <locale>: {
                  <stringcode>: <translation>,
                  ...
                  }
                  }
                */
                    if (!draft.translations) {
                        draft.translations = {}
                    }
                    if (!draft.translations[locale]) {
                        draft.translations[locale] = {}
                    }
                    // transform json to simple stringCode->translation dictionary
                    translations.forEach(entry => {
                        const { stringCode, translation } = entry
                        draft.translations[locale][stringCode] = translation
                    })
                }
            }
            break
        case ADD_MODULE_CONTEXT_CODE_SUCCESS:
            {
                const { contextCode, locale } = action
                if (!draft.moduleContextCodes) {
                    draft.moduleContextCodes = {}
                }
                if (!draft.moduleContextCodes[contextCode]) {
                    draft.moduleContextCodes[contextCode] = {}
                }
                // Remember, which contextCodes and which locales, translations have already been fetched
                draft.moduleContextCodes[contextCode][locale] = true
            }
            break
    }
}, {})
